import { useEffect, useRef } from "react";

const SELECTOR = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

export default function useAccessibleDialog(open, onClose) {
  const dialogRef = useRef(null);
  const openerRef = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    openerRef.current = document.activeElement;
    const dialog = dialogRef.current;
    const focusables = () => [...(dialog?.querySelectorAll(SELECTOR) || [])].filter(x => !x.hidden && x.getAttribute("aria-hidden") !== "true");
    requestAnimationFrame(() => (focusables()[0] || dialog)?.focus());
    const key = (event) => {
      if (event.key === "Escape") { event.preventDefault(); onClose(); return; }
      if (event.key !== "Tab") return;
      const nodes = focusables(); if (!nodes.length) { event.preventDefault(); return; }
      const first=nodes[0], last=nodes[nodes.length-1];
      if (event.shiftKey && document.activeElement===first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement===last) { event.preventDefault(); first.focus(); }
    };
    document.addEventListener("keydown", key);
    return () => { document.removeEventListener("keydown", key); openerRef.current?.focus?.(); };
  }, [open, onClose]);
  return dialogRef;
}
